import React, { useEffect } from 'react';
import { ATMField, ATMForm } from 'shared-it-appmod-ui';
import { getUser } from 'src/libraries/auth.library';
import { INewFireDispatchMethods } from 'src/models/fire-fighting-dispatch.model';

interface IProps extends INewFireDispatchMethods {
  dispatchId: number | null | undefined;
}

const DispatchUserInformationForm: React.FC<IProps> = ({
  control,
  dispatchId,
}) => {
  const userData = getUser();
  const editMode = Number(dispatchId) > 0;

  useEffect(() => {
    const userName = `${userData?.first_name} ${userData?.last_name}`;
    control.setValue('enteredBy', userName);
    if (editMode) {
      control.setValue('updatedBy', userName);
    }
  }, [userData]);

  return (
    <>
      <ATMField
        name="enteredBy"
        className="hidden"
        as={ATMForm.Input}
        control={control}
        type="hidden"
      />
      {editMode && (
        <ATMField
          name="updatedBy"
          className="hidden"
          as={ATMForm.Input}
          control={control}
          type="hidden"
        />
      )}
    </>
  );
};

export default DispatchUserInformationForm;
